import { Outlet } from 'react-router-dom';
import styles from './Layout.module.css';

export default function Layout() {
  return (
    <div className={styles.layout}>
      {/* `main-content` is the last-resort focus target when an app-level
          notice closes under keyboard focus (KeptRecordingNotice). The notice
          adds a temporary tabindex only while it places focus there. */}
      <main id="main-content" className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
